/* eslint-disable */
import React from 'react'
import FeatherIcon from 'feather-icons-react';

import Phone from '_assets/images/template/phone-black.svg';
import ExLink from '_assets/images/template/external-link-black.svg';
import ArrowBlack from '_assets/images/template/arrow-left-black.svg';

function ModalPhoneReview(props) {
  const {showModalPhone, buttonData} = props;
  console.log('buttonData prev', buttonData)
  return (
    <div className='modal-filter'>
      <div className='wrapper-side p-3'>
        <div className='d-flex align-items-center justify-content-between mb-3'>
          <span className='cl-neutral500 fweight-600'>All Options</span>
          <FeatherIcon onClick={()=>showModalPhone(false)} icon="x" className="cursor-pointer cl-grey-smoke" />
        </div>
        {buttonData && (
          <div>
            {buttonData.map((item, idxButton) => {
            return <div key={idxButton}>
              {item.buttonType === 'CTA' ?
              <div 
                className={`${idxButton === 0 && 'border-bottom mb-1'} d-flex align-items-center flex-column my-2`}
                >
                {item.buttons.map((resultButton, idx) => {
                  return <div key={idx} className='d-flex align-items-center flex-wrap cl-black fsize-14 mb-2'>
                      <img width="14" height="14" className={`${resultButton.type === 'PHONE_NUMBER' || resultButton.type === 'phone_number' ? '' : 'd-none'} me-2`} src={Phone} alt="" />
                      <img width="14" height="14" className={`${resultButton.type === 'URL' || resultButton.type === 'url' || resultButton.type === 'url_dynamic' || resultButton.type === 'static' ? '' : 'd-none'} me-2`} src={ExLink} alt="" />
                      {resultButton?.text}
                  </div> 
                })} 
              </div>
              : ''}
              {item.buttonType === 'QUICK_REPLY' ?
                <div 
                className={`${idxButton === 0 && 'border-bottom mb-1'} d-flex align-items-center flex-column my-2`}
                >
                  {item.buttons.map((resultButton, idx) => {
                    return <div key={idx} className='d-flex align-items-center flex-wrap cl-black fsize-14 mb-2'>
                      <img width="14" height="14" className={`me-2`} src={ArrowBlack} alt="" />
                      {resultButton?.text}
                    </div>
                  })}
                </div>
              : ''}
            </div>
          })}
          </div>
        )}
      </div>
    </div>
  )
}

export default ModalPhoneReview